import React, { useEffect, useState, useRef } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
  Divider,
  Modal,
  Fade,
  Box,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import esignImage from "../Components copy/assets/Images/EsignImage.jpg";
import { checkUserLoggedIn } from "../shared copy/commonfunctions";
import PdfModal from "../Components copy/PdfModal/PdfModal";
import WebcamDemo from "../Components copy/CameraModule/WebCamFaceDetection";
import {
  startOverAPICall,
  esignAPICall,
  requestEsignAPICall,
  getDocumentEsignAPICall,
  stageDetailsAPICall,
  CreatePdfEsignAPICall,
  CreateEsignRequestAPICall,
} from "../shared copy/APICalls";
import routesData from "../shared copy/routes.json";
import ESignStyles from "../pages copy/Styles/Esign.module.scss";
import AadhaarImage from "../Components copy/assets/Images/esignnewimage.svg";
import PDFViewerIframe from "../Components copy/PDFIframe/PDFWithIframe";
import CloseIcon from "@mui/icons-material/Close";
import StageLayout from "../Layouts/StageLayout";
import icon from "../Components copy/assets/Images/iconnew.svg";
import SnackBar from "../Components copy/SnackBars/SnackBar";
import StartOverBackDrop from "../Components copy/StartOverBackDrop";
import ErrorSnackBar from "../Components copy/SnackBars/ErrorSnackBar";
import backicon from "../Components copy/assets/Images/back.svg";
import keyboardicon from "../Components copy/assets/Images/esignicongrey.svg";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Store/Project/ProjectSlice";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import PDFViewerIframeEsign from "../Components copy/PDFIframe/PDFWithIframe";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "90vH",
  bgcolor: "background.paper",
  borderRadius: "20px",
  boxShadow: 24,
  padding: "10px 0px 0px 5px",
};

export default function EsignPage() {
  const dispatch = useDispatch();
  const [childWindowRef, setchildWindowRef] = useState<any>(null);
  const [closetTimer, setclosetTimer] = useState(false);
  const [loading, setloading] = useState(false);
  const [startOverloading, setstartOverloading] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [showModal, setshowModal] = useState(true);
  const [pdfUrl, setPdfUrl] = useState<any>("");
  const [continueOption, setcontinueOption] = useState(true);
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [continueEsignLoading, setcontinueEsignLoading] = useState(false);
  const [startloading, setstartloading] = useState(false);
  const [agentPlatform, setAgentPlatform] = useState("");

  const navigationData = routesData;
  const [ErrorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const timerRef = useRef<any>(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    checkUserLoggedIn(navigate);
    setloading(true);
    let obj: any = {
      stage: "e_sign",
    };
    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setloading(false);
        dispatch(setCompletedStages(responseData.completed_stages));
        dispatch(setCurrentStage(responseData.current_stage));

        if (responseData.data.ErrorMessage) {
          setRejectMessage(responseData.data.ErrorMessage);
        }

        if (
          responseData.data.data.url &&
          responseData.data.ErrorMessage === ""
        ) {
          setcontinueOption(false);

          setPdfUrl(responseData.data.data.url);
          if (
            responseData?.data?.next_stage &&
            navigationData.hasOwnProperty(responseData?.data?.next_stage)
          ) {
            navigate(navigationData[responseData?.data?.next_stage]);
          }
        }
      })
      .catch((error: any) => {
        //  console.log("error", error);
      });
    GenerateEsignPdf();

    const userAgent = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(userAgent)) {
      setAgentPlatform("iOS");
    } else if (/android/.test(userAgent)) {
      setAgentPlatform("Android");
    } else {
      setAgentPlatform("Other");
    }
  }, []);
  useEffect(() => {
    if (startloading) {
      setloading(true);
      if (pdfUrl) {
        setshowModal(true);
        setloading(false);
        setstartloading(false);
      }
    }
  }, [pdfUrl, startloading]);
  useEffect(() => {
    if (!closetTimer && childWindowRef) {
      //  console.log("timer trigger");
      timerRef.current = setInterval(checkChild, 500);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [childWindowRef, closetTimer]);

  const GenerateEsignPdf = () => {
    // setloading(true);
    CreatePdfEsignAPICall()
      .then((response: any) => {
        const responseData = response?.data?.data?.url;
        // console.log("responseData", responseData);
        setPdfUrl(response?.data?.data?.url ? response.data.data.url : "");
        // setloading(false);
      })
      .catch((error: any) => {
        setErrorMessage(error?.response?.data?.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
        // setloading(false);
      });
  };

  const handleEsignNow = () => {
    if (pdfUrl) {
      setshowModal(true);
      setloading(false);
    } else {
      handleEsignNow();
    }
  };

  const openHtmlPage = (htmlString: string) => {
    const blob = new Blob([htmlString], { type: "text/html" });
    const url = URL.createObjectURL(blob);

    window.location.href = url;
  };

  const handleOpenClick = () => {
    let digilink: string = "";
    setcontinueEsignLoading(true);

    CreateEsignRequestAPICall()
      .then((response: any) => {
        const responseData = response?.data;

        // console.log("responseData", responseData.data);

        var url = responseData?.data?.esp_html;
        var trimmedUrl = url.replace(":444", "");
        digilink = url;
        // if (agentPlatform === "iOS") {

        openHtmlPage(digilink);
        // window.location.href = digilink;
        // } else {
        //   const childWindow: any = window.open(
        //     digilink,
        //     "_blank",
        //     "width=500,height=700"
        //   );
        //   setchildWindowRef(childWindow);
        // }

        // setcontinueEsignLoading(false);
      })
      .catch((error: any) => {
        setloading(false);
        setcontinueEsignLoading(false);
        setErrorMessage(
          error?.message?.includes("Network")
            ? "Error occured, Please try again"
            : error?.response?.data?.message,
        );
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      });
  };
  const handleContinue = () => {
    setOpen(false);
    setloading(false);
  };

  function eSign() {
    setloading(true);
    esignAPICall()
      .then((response: any) => {
        const responseData = response?.data;
        // console.log("responseData", response);
        setloading(false);

        if (
          responseData?.data?.stage &&
          navigationData.hasOwnProperty(responseData?.data?.stage)
        ) {
          navigate(navigationData[responseData?.data?.stage]);
        }
      })
      .catch((error: any) => {
        //  console.log("error", error);
        setloading(false);
      });
  }

  function checkChild() {
    // console.log("timer");

    if (childWindowRef && childWindowRef.closed) {
      clearInterval(timerRef.current);

      let obj: any = {
        stage: "esign",
      };

      stageDetailsAPICall(obj)
        .then((response: any) => {
          const responseData = response?.data;
          setloading(false);
          if (responseData?.data?.data?.url) {
            navigate("/congratulations");
            setloading(true);
          }

          setPdfUrl(responseData?.data?.data?.url);
          setloading(false);
        })
        .catch((error: any) => {
          //  console.log("error", error);
        });
    }
  }

  const handlePreviewClick = () => {
    setshowModal(true);
  };

  return (
    <div className={ESignStyles.mainWrapperTop}>
      <SnackBar message={ErrorMessage} />
      <ErrorSnackBar message={rejectMessage} />

      <div className={ESignStyles.wrapper}>
        {/* <div
          className={ESignStyles.back}
          onClick={() => {
            if (showModal) {
              setshowModal(false);
            } else {
              navigate("/ipv");
            }
          }}
        >
          <img src={backicon} />{" "}
          <span className={ESignStyles.backText}>Back</span>
        </div> */}
        {showModal ? (
          <p className={ESignStyles.almostThereText}>Esign Preview</p>
        ) : (
          <div className={ESignStyles.step}>
            <img src={keyboardicon} /> Step 10 of 10
          </div>
        )}
        {showModal ? (
          ""
        ) : (
          <div className={ESignStyles.titleSection}>
            <p className={ESignStyles.almostThereText}>Almost There!</p>

            <p className={ESignStyles.title}>
              {" "}
              Digitally sign your application
            </p>
          </div>
        )}
        {!showModal ? (
          <div className={ESignStyles.container}>
            <div className={ESignStyles.leftcontainer}>
              <div>
                <div className={ESignStyles.textdiv}>
                  <p className={ESignStyles.instructiontext}>
                    <DoneOutlinedIcon style={{ color: "#049981" }} /> Click on
                    the E-Sign Button Below..
                  </p>
                  <p className={ESignStyles.instructiontext}>
                    <DoneOutlinedIcon style={{ color: "#049981" }} /> Enter Your
                    Aadhaar Number.
                  </p>
                  <p className={ESignStyles.instructiontext}>
                    <DoneOutlinedIcon style={{ color: "#049981" }} /> Enter the
                    OTP sent to your registered mobile number.
                  </p>
                </div>
                <div>
                  <>
                    <div className={ESignStyles.buttonStyles}>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {continueOption ? (
                          <LoadingButton
                            type="submit"
                            variant="contained"
                            onClick={() => {
                              setstartloading(true);
                            }}
                            loading={loading}
                            id="aadharOpenLinkButton"
                            className={ESignStyles.esignButton}
                            sx={{ width: "187px", height: "50px" }}
                          >
                            Esign Now
                          </LoadingButton>
                        ) : (
                          <>
                            <div className={ESignStyles.sectionButton}>
                              <LoadingButton
                                className={ESignStyles.esignButton}
                                type="submit"
                                variant="contained"
                                sx={{ width: "187px", height: "50px" }}
                                onClick={handleContinue}
                                loading={loading}
                                id="aadharOpenLinkButton"
                              >
                                Continue
                              </LoadingButton>
                              <Button
                                className={ESignStyles.esignPreview}
                                type="submit"
                                variant="outlined"
                                sx={{
                                  color: "#1F2937",
                                  marginLeft: "10px",
                                  height: "50px",
                                }}
                                onClick={handlePreviewClick}
                                id="aadharOpenLinkButton"
                              >
                                View E-sign Document
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                      {backdrop && <StartOverBackDrop />}
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={ESignStyles.modalContainer}>
            <div className={ESignStyles.pdfMobilePreview}>
              <img
                src={esignImage}
                style={{
                  width: "95%",
                  height: "100%",
                  objectFit: "inherit",
                  // filter: "brightness(80%)",
                  border: "5px solid #525659",
                  marginBottom: "20px",
                }}
              />
            </div>
            <div className={ESignStyles.pdfDesktopPreview}>
              {pdfUrl ? (
                <PDFViewerIframeEsign urldata={pdfUrl} />
              ) : (
                <div
                  style={{
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #525659",
                    background: "#525659",
                  }}
                >
                  <CircularProgress style={{ color: "#fff" }} />
                </div>
              )}
            </div>
            <Stack marginTop={"20px"} direction={"row"}>
              <LoadingButton
                loading={continueEsignLoading}
                variant="contained"
                sx={{
                  width: "150px",
                  margin: "auto",
                  height: "50px",
                }}
                onClick={handleOpenClick}
              >
                Continue
              </LoadingButton>
              {/* <a
                href={pdfUrl}
                download="Esign-PDF-document"
                target="_blank"
                rel="noreferrer"
                className={ESignStyles.previewdownlaodesign}
              >
                <Button
                  variant="outlined"
                  sx={{
                    color: "#1F2937",
                    height: "50px",
                  }}
                >
                  View Esign PDF
                </Button>
              </a> */}
            </Stack>
          </div>
        )}
      </div>
    </div>
  );
}